export const initialValues = (idSurvey: string | undefined) => ({
    surveyId: idSurvey,
    type: '',
    required: true,
    gateSurveyUntilValidated: false,
    description: '',
    icon: 'circle',
    why: false,
    status: 'active',
    dependency: false,
    questionDependency: '',
    answerDependency: '',
    range1: '',
    range2: '',
});
